import Default from '@app/constants';
import { get, set } from 'lockr';
import { FilterRider } from '@app/typings/services/winnonie/rider';
import { getRowsPerPage } from '@app/utils/localStorage';

const filterRider: string = 'winnonie/rider.filters';
const riderName: string = 'winnonie/riderName';

export const setFilterRiderWinnonie = (value: FilterRider) => {
  set(filterRider, value);
};
export const getFilterRiderWinnonie = (): FilterRider => {
  return get(filterRider) || { filters: Default.filter.winnonie.rider, pages: Default.pages };
};
export const clearFilterRiderWinnonie = () => {
  return set(filterRider, {
    filters: Default.filter.winnonie.evLockersBrandLevel,
    pages: {
      offset: Default.pages.offset,
      limit: getFilterRiderWinnonie().pages.limit || Number(getRowsPerPage()),
    },
  });
};
export const setRiderName = (value: string) => {
  set(riderName, value);
};
export const getRiderName = (): string => {
  return get(riderName);
};
